export const AUTH_BRAND_CONTENT = {
  signIn: {
    title: "Welcome Back!",
    paragraphs: [
      "Continue your scientific experiments.",
      "Access your workspaces, jobs, datasets, and workflows from a single platform.",
    ],
    bulletsTitle: "What you can do with EFabric",
    bullets: [
      "Develop experiments interactively with Workspaces",
      "Scale workloads through Jobs",
      "Track results and artifacts",
      "Reproduce and share experiments",
    ],
  },
  signUp: {
    title: "Create Your EFabric Account",
    paragraphs: [
      "Start building AI-driven scientific experiments in minutes.",
      "Join researchers using EFabric to develop, scale, reproduce, and share scientific workloads.",
    ],
    bulletsTitle: "Benefits",
    bullets: [
      "Deploy experiments without infrastructure setup",
      "Access CPUs and GPUs through a unified platform",
      "Reproduce and share scientific workflows",
      "Scale from development to production workloads",
    ],
  },
  forgotPassword: {
    title: "Forgot your password?",
    paragraphs: [
      "It happens. Enter your email and we'll send reset instructions if an EFabric account exists.",
      "EFabric is an AI4Science platform open to researchers at UW-Madison.",
    ],
    bulletsTitle: "What happens next",
    bullets: [
      "We email a one-time reset link to your address",
      "Open the link and choose a new password",
      "Sign in and pick up right where you left off",
    ],
  },
  resetPassword: {
    title: "Set a new password",
    paragraphs: [
      "Choose a strong password to keep your EFabric account secure.",
      "EFabric is an AI4Science platform open to researchers at UW-Madison.",
    ],
    bulletsTitle: "Tips for a strong password",
    bullets: [
      "Use at least 8 characters",
      "Mix upper and lower case letters",
      "Include a number and a symbol",
      "Avoid reusing old passwords",
    ],
  },
};

export const AUTH_FORM_HEADERS = {
  signIn: {
    title: "Sign in to your account",
    subtitle: "Enter your details to continue.",
  },
  signUp: {
    title: "Create your account",
    subtitle: "Tell us a bit about you to get started.",
  },
  forgotPassword: {
    title: "Reset your password",
    subtitle: "Enter your email and we'll send you a reset link.",
  },
  resetPassword: {
    title: "Reset your password",
    subtitle: "Enter a new password and confirm it below.",
  },
};
